import React from "react";

export const TicketStatusContainer = (statusId: number, statusName: string) => {
  switch (statusId) {
    case 1:
      return (
        <React.Fragment>
          <div className="bg-info badge">{statusName}</div>
        </React.Fragment>
      );
    case 2:
      return (
        <React.Fragment>
          <div className="bg-warning badge">{statusName}</div>
        </React.Fragment>
      );
    case 3:
      return (
        <React.Fragment>
          <div className="bg-success badge">{statusName}</div>
        </React.Fragment>
      );
    case 4:
      return (
        <React.Fragment>
          <div className="bg-secondary badge">{statusName}</div>
        </React.Fragment>
      );
  }
};
